import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { StateService } from '../../services/states.service';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = true;
  private subscription: Subscription;
  constructor(private stateService: StateService) { }
  ngOnInit() {
    this.subscription = this.stateService.loader
    .subscribe((state) => {
      this.show = state;
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}